import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BigStoryCardCurve from "../big-story-card-curve/index";
import SmallStoryCardCurve from "../small-story-card-curve/index";

import styles from "./styles.m.css";

const MultipleStoryFourCollectionStoryStack = ({
  bigStory,
  mobileStoryCount,
  stories,
  className,
  verticalimg = true,
  bigimage,
  bigStoryHover = false
}) => {
  if (stories.length < 1) {
    return null;
  }
  const [pageName, setPageName] = useState("home");

  useEffect(() => {
    const getpageName = global && global.location.pathname;
    const pageName = getpageName.split("/").pop();
    const getPFrom = pageName || "home";
    setPageName(getPFrom);
  }, []);
  const stack = [
    <BigStoryCardCurve
      story={stories[0]}
      key={stories[0].id}
      // className={`${styles["index-one"]}`}
      bigimage={bigimage}
      pFrom={`${pageName}-fourteen-story-collection`}
      iconbottomright={true}
    />
  ].concat(
    stories
      .slice(1)
      .map((story, index) => (
        <SmallStoryCardCurve
          story={story}
          verticalimg={false}
          className={`${styles["line-separater"]}`}
          key={story.id}
          pFrom={`${pageName}-fourteen-story-collection`}
          iconbottomright={true}
        />
      ))
  );
  return <div className={`${styles["base"]} ${className}`}>{stack}</div>;
};

MultipleStoryFourCollectionStoryStack.propTypes = {
  bigStory: PropTypes.bool,
  verticalimg: PropTypes.bool,
  bigimage: PropTypes.bool,
  mobileStoryCount: PropTypes.number,
  stories: PropTypes.arrayOf(BigStoryCardCurve.propTypes.story),
  className: PropTypes.string,
  bigStoryHover: PropTypes.bool
};

export default MultipleStoryFourCollectionStoryStack;
